import React from 'react';
import { IIconProps } from './utils';

export const BackTo = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 18 20" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M16.5 18.75V10C16.5 7.92893 14.8211 6.25 12.75 6.25H1.5M1.5 6.25L6.5 1.25M1.5 6.25L6.5 11.25" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
  </svg>
);
